import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <footer className="footer">
            <p>Copyright &copy; 2021 Amante James</p>
        </footer >
    )
}

export default Footer
